import { feathersClient } from './index';

export const Cars = feathersClient.service('cars');
export const PurchasePlan = feathersClient.service('purchase-plan');
export const Settings = feathersClient.service('settings');
export const Campaigns = feathersClient.service('campaigns');
export const CampaignLeads = feathersClient.service('campaign-leads');
